import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClientHeaderModule } from '@modules';
import { ClientContainerRoutingModule } from './client-container-routing.module';
import { ClientContainerComponent } from './client-container.component';
import { ModalNewInvitationModule } from '@modules';

@NgModule({
  declarations: [ClientContainerComponent],
  imports: [
    CommonModule,
    ClientContainerRoutingModule,
    ClientHeaderModule,
    ModalNewInvitationModule,
  ],
  exports: [ClientContainerComponent],
})
export class ClientContainerModule {}
